import React from "react";
import { useSearchParams } from "react-router-dom";
import { Send, Hourglass, Ban } from "lucide-react";
import AccessShell from "@/components/AccessShell";

const STATES = {
  requested: { icon: Send, color: "text-amber-600 bg-amber-50 border-amber-200", title: "Deine Anfrage wurde gesendet",
    text: "Du bekommst eine E-Mail, sobald dein Zugang freigegeben ist." },
  pending: { icon: Hourglass, color: "text-amber-600 bg-amber-50 border-amber-200", title: "Deine Anfrage wird noch geprüft",
    text: "Du bekommst eine E-Mail, sobald dein Zugang freigegeben ist." },
  rejected: { icon: Ban, color: "text-red-600 bg-red-50 border-red-200", title: "Dein Zugang wurde nicht freigegeben",
    text: "Bitte wende dich an den Betreiber von PrüfDoc Pro, falls du Fragen hast." },
};

export default function AccessStatus() {
  const [params] = useSearchParams();
  const key = STATES[params.get("s")] ? params.get("s") : "pending";
  const st = STATES[key];
  return (
    <AccessShell testid={`access-status-${key}`}>
      <div className={`h-14 w-14 rounded-2xl border flex items-center justify-center mb-4 ${st.color}`}>
        <st.icon className="h-7 w-7" />
      </div>
      <h1 className="text-2xl font-head font-extrabold tracking-tight mb-2" data-testid="access-status-title">{st.title}</h1>
      <p className="text-slate-600" data-testid="access-status-text">{st.text}</p>
    </AccessShell>
  );
}
